module.exports = __webpack_public_path__ + "img/admin_adv_18.2ece5158.png";